import { isDefined, isObject } from 'class-validator';

export default {
  data() {
    return {
      activeTrigger: null,
      customFormsData: [],
      pendingStatusChange: null
    };
  },
  computed: {
    hasActiveTrigger() {
      return isObject(this.activeTrigger);
    },
    hasCustomFormsData() {
      return this.customFormsData?.skip === true || this.customFormsData?.length > 0;
    }
  },
  methods: {
    cleanUpCustomFormsData() {
      this.activeTrigger = null;
      this.pendingStatusChange = null;
      this.customFormsData = [];
    },
    checkForTriggerOnStatus(status) {
      let category = null;

      // Do not set the active trigger if we have pending data to submit
      if (this.hasCustomFormsData || isDefined(this.pendingStatusChange)) {
        return;
      }

      const entityName = this.novaCore.CustomFormFlowEntitiesEnum.warehouse;
      const app = this.novaCore.AppsEnum.Warehouse;

      if (status === this.novaCore.AppointmentStatus.Completed) {
        category = this.novaCore.CustomFormFlowCategoryEnum.appointmentStatusCompleted;
      }

      if (status === this.novaCore.AppointmentStatus.Arrived) {
        category = this.novaCore.CustomFormFlowCategoryEnum.appointmentStatusArrived;
      }

      return this.$selectedWarehouseTriggers.find(
        trigger =>
          (!app || trigger.app === app) &&
          (!entityName || trigger.entityName === entityName) &&
          trigger.category === category &&
          trigger.isActive
      );
    }
  }
};
